module.exports = __webpack_public_path__ + "static/logo-4d8d3da1811ecc735168581dd1114e25.png";